module.exports = __webpack_public_path__ + "media/en_us_s2_Earl.6d868f21.mp3";